module.exports = __webpack_public_path__ + "static/media/course_1-alt-photo.93f09328.png";